module.exports = __webpack_public_path__ + "static/media/conLogo1.8f479fef.jpg";